/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import Tarjeta_Valores_Home from "../Tarjetas/Tarjeta_Valores_Home";
import audio from '../../../../Recursos/ic_audio.svg'
import espi from '../../../../Recursos/ic_espino.svg'
import optp from '../../../../Recursos/ic_opto.svg'
import bebe from '../../../../Recursos/ic_bebe.svg'
import trabajo from '../../../../Recursos/ic_ocupacion.svg'
import orientacino from '../../../../Recursos/ic_orientacion.svg'
import tareas from '../../../../Recursos/ic_tareas.svg'

import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Lista_Tarjeta_Valores_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={12}
            spacing={sCell ? 8 : 14}>
            {valores.map((valor, index) => (

                <Grid2 container size={{xs: 12, sm: 6, md: 4}}>
                    <Tarjeta_Valores_Home
                        imagen={valor.imagen}
                        titulo={valor.titulo}
                        parrafo={valor.parrafo}/>
                </Grid2>

            ))}
        </Grid2>
    )

}
export default Lista_Tarjeta_Valores_Home


const valores = [

    {
        imagen: audio,
        titulo: 'Fonoaudiología',
        parrafo: 'Potenciamos el habla, el lenguaje y la comunicación, eliminando barreras para que cada persona se exprese con claridad.'
    },
    {
        imagen: espi,
        titulo: 'Psicología',
        parrafo: 'Brindamos apoyo emocional y herramientas prácticas para fortalecer la autoestima, la salud mental y la sana convivencia familiar.'
    },
    {
        imagen: optp,
        titulo: 'Pre y Seguimiento Escolar',
        parrafo: 'Realizamos un acompañamiento académico continuo, adaptando estrategias pedagógicas para asegurar el éxito y la motivación del estudiante.'
    },
    {
        imagen: trabajo,
        titulo: 'Terapia Ocupacional',
        parrafo: 'Desarrollamos habilidades motoras y sensoriales para que nuestros usuarios logren independencia en su vida diaria y escolar.'
    },
    {
        imagen: orientacino,
        titulo: 'Orientación Vocacional',
        parrafo: 'Guiamos a los jóvenes en el descubrimiento de sus talentos y pasiones para que elijan con seguridad su futuro profesional.'
    }
    ,
    {
        imagen: tareas,
        titulo: 'Apoyo de Tareas',
        parrafo: 'Reforzamos el cumplimiento de deberes escolares, fomentando hábitos de estudio y organización que facilitan el aprendizaje diario.'
    }
    ,
    {
        imagen: bebe,
        titulo: 'Estimulación Temprana',
        parrafo: 'Intervención especializada para niños con riesgo neurológico, potenciando su neurodesarrollo y plasticidad cerebral desde los primeros años.'
    }

]